var _a, _b;
import { makeStyles } from '@fluentui/react-components';
import { iconFilledClassName, iconRegularClassName, } from '@fluentui/react-icons';
// https://github.com/microsoft/fluentui-system-icons/tree/master/packages/react-icons#user-flows
export var useActionMenuIconsStyles = makeStyles({
    regularIcon: (_a = {},
        _a["& .".concat(iconFilledClassName)] = {
            display: 'none',
        },
        _a["& .".concat(iconRegularClassName)] = {
            display: 'inline',
        },
        _a),
    filledIcon: (_b = {},
        _b["& .".concat(iconFilledClassName)] = {
            display: 'inline',
        },
        _b["& .".concat(iconRegularClassName)] = {
            display: 'none',
        },
        _b),
});
//# sourceMappingURL=ActionContextMenuIcons.styles.js.map